import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-field-error',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (errors) {
      <div class="text-red-500 text-xs mt-1" aria-live="polite" [attr.data-cy]="dataCy">
        @for (error of errors; track error) {
          <div>{{ error }}</div>
        }
      </div>
    }
  `,
  styles: []
})
export class FormFieldErrorComponent {
  @Input() errors: string[] | null = null;
  @Input() dataCy: string = '';
}
